import { StateCreator } from "zustand";
import {
  AuthSlice,
  MessageSlice,
  ThemeSlice,
  RegisterSlice,
  SectionSlice,
  OptionSlice,
  OrganizationSlice,
} from "../../interfaces";

export const createMessageSlice: StateCreator<
  RegisterSlice &
    SectionSlice &
    MessageSlice &
    AuthSlice &
    OptionSlice &
    OrganizationSlice &
    ThemeSlice,
  [["zustand/persist", unknown]],
  [],
  MessageSlice
> = (set: any, get: any) => {
  return {
    messageZustand: "",
    messageTypeZustand: "",
    linkZustand: null,
    setMessageZustand(message: string, messageType: string) {
      set({
        messageZustand: message,
        messageTypeZustand: messageType,
        linkZustand: null,
      });
    },
    removeMessageZustand() {
      set({
        messageZustand: null,
        messageTypeZustand: null,
        linkZustand: null,
      });
    },
  };
};
